<script setup lang="ts" generic="T extends string">
import { ArrowUpDown, Check, ChevronDown } from 'lucide-vue-next'
import type { ListSortOption } from '@/types/listFilters'

const props = defineProps<{
  options: ListSortOption<T>[]
}>()

const model = defineModel<T>({ required: true })

const { t } = useI18n()

const currentLabel = computed(() => props.options.find((option) => option.value === model.value)?.label)

const select = (value: unknown) => {
  const option = props.options.find((item) => item.value === value)
  if (option) model.value = option.value
}
</script>

<template>
  <DropdownMenu>
    <DropdownMenuTrigger as-child>
      <Button
        variant="outline"
        :aria-label="t('listFilters.sortByValue', { label: currentLabel })"
        data-testid="list-sort-menu"
      >
        <ArrowUpDown />
        {{ currentLabel }}
        <ChevronDown class="text-muted-foreground" />
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end" class="w-56">
      <DropdownMenuLabel class="px-2 text-xs font-medium text-muted-foreground">
        {{ t('listFilters.sortBy') }}
      </DropdownMenuLabel>
      <DropdownMenuRadioGroup :model-value="model" @update:model-value="select">
        <DropdownMenuRadioItem
          v-for="option in options"
          :key="option.value"
          :value="option.value"
          class="pl-2"
          :data-testid="`list-sort-option-${option.value}`"
        >
          <template #indicator-icon>
            <span />
          </template>
          <span class="flex-1">{{ option.label }}</span>
          <Check v-if="option.value === model" class="text-foreground" />
        </DropdownMenuRadioItem>
      </DropdownMenuRadioGroup>
    </DropdownMenuContent>
  </DropdownMenu>
</template>
